module.exports = __webpack_public_path__ + "static/img/AiTalk2.369748f0.gif";